import React, {
    Component
} from 'react'
import {
    Nav,
    NavLink,
    Link,
} from 'react-router-dom'

import Icon from '@material-ui/core/Icon';
import Chip from '@material-ui/core/Chip';
import Tooltip from '@material-ui/core/Tooltip';

const AnchorLink = (props)=>{
    return <a href={props.link} target="_blank">{props.children}</a>;
}

export default function ChipDetails(props){
    let text = (
        <React.Fragment>
            {props.label}
            {!props.link ? null : (
                <React.Fragment>
                    &nbsp;&nbsp;
                    <div className="icon-circle">
                        <span className="icon-circle-glyph mdi mdi-arrow-top-right-thick"/>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    )

    let chip = (
        <Chip
            className={(props.status === 'error' ? 'chip chip-error chip-grow' : 'chip chip-success chip-grow')}
            label={text}
        />
    );

    let tooltip = (
        <Tooltip
            interactive
            placement='top'
            title={props.tooltip}
        >
            {chip}
        </Tooltip>
    );

    let Component = React.Fragment;
    if(props.link){
        Component = AnchorLink;
    }
    return (
        <Component {...props}>
            {props.tooltip ? tooltip : chip}
        </Component>
    );
}